import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context as RestaurantContext } from '../../context/restaurant';

import logo from '../../assets/images/footer/logo.png';
import visa from '../../assets/images/footer/visa.png';
import mastercard from '../../assets/images/footer/mastercard.png';
import googlePay from '../../assets/images/footer/google-pay.png';
import applePay from '../../assets/images/footer/apple-pay.png';
// import { formatFullRestaurantAddress } from '../../utils/stringHelper';

const FooterPlace = ({ showPayments }) => {
  const { t } = useTranslation();
  const { state: restaurantState } = useContext(RestaurantContext);

  const showCompanyDetails =
    restaurantState.restaurant && restaurantState.restaurant.showCompanyDetails;

  const renderCompanyDetails = () => {
    if (!showCompanyDetails) {
      return null;
    }

    // const fullAddress = formatFullRestaurantAddress(restaurantState.restaurant);

    return (
      <div className="mb-2 flex flex-col items-center">
        {!!restaurantState.restaurant.companyName && (
          <div className="font-primaryMedium text-xs text-bland mb-1">
            {restaurantState.restaurant.companyName}
          </div>
        )}
        {!!restaurantState.restaurant.registeredCompanyAddress && (
          <div className="font-primaryMedium text-xs text-bland mb-1">
            {restaurantState.restaurant.registeredCompanyAddress}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-col justify-center items-center">
      {showCompanyDetails && renderCompanyDetails()}
      {showPayments && (
        <div className="flex flex-row  items-center mix-blend-luminosity">
          <img className="mr-3 max-h-5" src={visa} alt="Visa" />
          <img className="mr-3 max-h-4" src={mastercard} alt="Mastercard" />
          <img className="mr-3 max-h-4" src={applePay} alt="Apple Pay" />
          <img className="max-h-4" src={googlePay} alt="Google Pay" />
        </div>
      )}
      <div className="mt-2 flex flex-row items-center">
        <span className="font-primaryMedium text-xs text-bland">{t('common.poweredByApp')}</span>{' '}
        <img className="ml-1 h-3  mb-[2px]" src={logo} alt="Waitless" />
      </div>
    </div>
  );
};

export default FooterPlace;
